import React from "react";
import PropTypes from "prop-types";
import { CarouselProvider, Slider, Slide } from "pure-react-carousel";

import "pure-react-carousel/dist/react-carousel.es.css";
import carousel from "./carousel.module.scss";
import Slides from "./Slides";

const Carousel = props => {
  const { dataSlides } = props;
  return (
    <CarouselProvider
      className={carousel.carouselProvider}
      naturalSlideWidth={100}
      naturalSlideHeight={125}
      totalSlides={dataSlides.length}
      interval={6000}
      isPlaying>
      <Slider>
        {dataSlides.map((obj, index) => (
          <Slide className={carousel.slides} index={index} key={obj.id}>
            <Slides obj={obj} />
          </Slide>
        ))}
      </Slider>
    </CarouselProvider>
  );
};

Carousel.propTypes = {
  dataSlides: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default Carousel;
